(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestResultDeleteController', ObjectTestResultDeleteController);

    ObjectTestResultDeleteController.$inject = ['$uibModalInstance', 'name', 'ObjectTestResult', 'type'];

    function ObjectTestResultDeleteController($uibModalInstance, name, ObjectTestResult, type) {
        var vm = this;
        vm.name = name;
        vm.type = type;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function () {
            ObjectTestResult.deletePdf({name: name, type: type}).$promise.then(function () {
                $uibModalInstance.close();
            });
        };
    }
})();
